import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import '@fontsource/manrope/200.css';
import '@fontsource/manrope/300.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import { ThemeProvider } from './ThemeProvider.tsx';
import { BrowserRouter } from 'react-router-dom';
import { CurrencyContextProvider } from './components/ConfigurationProvider.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
    <ThemeProvider>
      <CurrencyContextProvider>
       <App />
      </CurrencyContextProvider>
    </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
)
